// Custom Guard that keeps the voucher and the thee item together
  (function () {
    if (window.__onpulseChooseLaterPairRemoveGuard) return;
    window.__onpulseChooseLaterPairRemoveGuard = true;

    var VOUCHER_VARIANT_ID = 57505027260799;
    var SIZING_KIT_VARIANT_ID = 57450847895935;

    var removeInProgress = false;
    var lastToastAt = 0;

    function getRootUrl() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function isPairVariantId(variantId) {
      return Number(variantId) === Number(VOUCHER_VARIANT_ID) ||
        Number(variantId) === Number(SIZING_KIT_VARIANT_ID);
    }

    function getVariantIdFromKey(key) {
      if (!key) return null;

      var firstPart = String(key).split(':')[0];
      var variantId = Number(firstPart);

      return Number.isFinite(variantId) ? variantId : null;
    }

    function getCartChangeParamsFromHref(href) {
      var result = {
        key: null,
        variantId: null,
        line: null,
        quantity: null
      };

      if (!href) return result;

      try {
        var url = new URL(href, window.location.origin);
        var id = url.searchParams.get('id');
        var line = url.searchParams.get('line');
        var quantity = url.searchParams.get('quantity');

        if (id) {
          result.key = decodeURIComponent(id);
          result.variantId = getVariantIdFromKey(result.key);
        }

        if (line) {
          result.line = Number(line);
        }

        if (quantity !== null) {
          result.quantity = Number(quantity);
        }
      } catch (error) {
        return result;
      }

      return result;
    }

    function showChooseLaterPairMessage(type) {
      var now = Date.now();

      if (now - lastToastAt < 900) return;
      lastToastAt = now;

      var messageLine1 = 'Sizing kit and voucher must stay together.';
      var messageLine2 = 'Both are needed for Choose size later.';

      if (type === 'error') {
        messageLine1 = 'Bundle update could not be completed.';
        messageLine2 = 'Please refresh the cart and try again.';
      }

      var existing = document.querySelector('[data-onpulse-bundle-toast]');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.setAttribute('data-onpulse-bundle-toast', 'true');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      toast.innerHTML =
        '<div style="font-size:14px;font-weight:800;margin-bottom:4px;">' + messageLine1 + '</div>' +
        '<div style="font-size:13px;font-weight:600;opacity:0.82;">' + messageLine2 + '</div>';

      toast.style.position = 'fixed';
      toast.style.left = '50%';
      toast.style.top = '50%';
      toast.style.transform = 'translate(-50%, -50%) scale(0.98)';
      toast.style.zIndex = '999999';
      toast.style.maxWidth = 'calc(100vw - 44px)';
      toast.style.width = 'min(380px, calc(100vw - 44px))';
      toast.style.padding = '15px 17px';
      toast.style.borderRadius = '16px';
      toast.style.background = 'rgba(10,16,48,0.97)';
      toast.style.border = '1px solid rgba(49,197,208,0.44)';
      toast.style.boxShadow = '0 18px 45px rgba(0,0,0,0.45), 0 0 24px rgba(49,197,208,0.10)';
      toast.style.color = '#ffffff';
      toast.style.lineHeight = '1.38';
      toast.style.textAlign = 'center';
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 180ms ease, transform 180ms ease';
      toast.style.pointerEvents = 'none';
      toast.style.backdropFilter = 'blur(10px)';
      toast.style.webkitBackdropFilter = 'blur(10px)';

      document.body.appendChild(toast);

      window.requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.transform = 'translate(-50%, -50%) scale(1)';
      });

      window.setTimeout(function () {
        toast.style.opacity = '0';
        toast.style.transform = 'translate(-50%, -50%) scale(0.98)';

        window.setTimeout(function () {
          if (toast && toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, 240);
      }, 4000);
    }

    function fetchCart() {
      return fetch(getRootUrl() + 'cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not fetch cart.');
        return response.json();
      });
    }

    function removeBundleLines(keys) {
      var updates = {};

      keys.forEach(function (key) {
        if (key) updates[key] = 0;
      });

      return fetch(getRootUrl() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates,
          sections: ['mini-cart'],
          sections_url: window.location.pathname
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not remove Choose Size Later bundle.');
        return response.json();
      });
    }

    function findChooseLaterBundleItems(cart) {
      var voucherItem = null;
      var sizingKitItem = null;

      if (!cart || !Array.isArray(cart.items)) {
        return {
          voucherItem: null,
          sizingKitItem: null
        };
      }

      cart.items.forEach(function (item) {
        var variantId = Number(item.variant_id || item.id || 0);

        if (variantId === Number(VOUCHER_VARIANT_ID)) {
          voucherItem = item;
        }

        if (variantId === Number(SIZING_KIT_VARIANT_ID)) {
          sizingKitItem = item;
        }
      });

      return {
        voucherItem: voucherItem,
        sizingKitItem: sizingKitItem
      };
    }

    function updateVisibleCartCount(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;

      var count = cart.item_count;

      document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count, .cart-item-count, .cart-count, cart-count').forEach(function (el) {
        el.setAttribute('data-count', String(count));

        if (count > 0) {
          el.removeAttribute('hidden');
          el.classList.remove('hidden', 'is-hidden');
          el.textContent = count;
        } else {
          el.setAttribute('hidden', '');
          el.textContent = '';
        }
      });
    }

    function dispatchCartUpdate(cart) {
      updateVisibleCartCount(cart);

      [document, document.documentElement].forEach(function (target) {
        target.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));

        target.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: false
          }
        }));
      });
    }

    async function handlePairRemove(event, removeLink) {
      if (removeInProgress) {
        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        return;
      }

      var href = removeLink.getAttribute('href') || '';
      var params = getCartChangeParamsFromHref(href);

      if (params.quantity !== 0) return;

      if (params.variantId && !isPairVariantId(params.variantId)) {
        return;
      }

      if (!params.variantId) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      try {
        removeInProgress = true;

        var cart = await fetchCart();
        var bundle = findChooseLaterBundleItems(cart);

        var keysToRemove = [];

        if (bundle.voucherItem && bundle.voucherItem.key) {
          keysToRemove.push(bundle.voucherItem.key);
        }

        if (bundle.sizingKitItem && bundle.sizingKitItem.key) {
          keysToRemove.push(bundle.sizingKitItem.key);
        }

        if (!keysToRemove.length) return;

        var updatedCart = await removeBundleLines(keysToRemove);

        showChooseLaterPairMessage();
        dispatchCartUpdate(updatedCart);
      } catch (error) {
        console.error('[Onpulse] Choose Size Later pair remove failed:', error);
        showChooseLaterPairMessage('error');
      } finally {
        removeInProgress = false;
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || !target.closest) return;

      var removeLink = target.closest(
        'a[href*="/cart/change"], .line-item__remove-button, [data-action="remove-from-cart"], [data-cart-remove]'
      );

      if (!removeLink) return;

      handlePairRemove(event, removeLink);
    }, true);
  })();
